// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"36b24b2a","251":"b7b1bc79","334":"a3c2d3bc","348":"f0590036","571":"e104e4f0"}[chunkId] + ".chunk.js";
};